import { StepSection } from "@components/StepSection";
import { Skeleton } from "@components/UI/Skeleton";
import styles from "./StepSkeleton.module.css";

export function StepSkeleton() {
  return (
    <StepSection>
      <div className={styles.container}>
        {/* Title area */}
        <div className={styles.titleBlock}>
          <Skeleton height={38} width="65%" />
          <Skeleton height={19} width="88%" />
        </div>

        {/* Card 1 */}
        <div className={styles.cardSkeleton}>
          <Skeleton height={19} width="55%" />
          <Skeleton height={17} width="78%" />
        </div>

        {/* Card 2 */}
        <div className={styles.cardSkeleton}>
          <Skeleton height={19} width="55%" />
          <Skeleton height={17} width="78%" />
        </div>
      </div>
    </StepSection>
  );
}
